import Paypal from "components/Paypal";
import useAddSeats from "api/SubscriptionsResource/useAddSeats";
import { formatCurrencyAmount } from "utils";
export default function PayPal({ subscriptionId, additionalSeats, totalAmount, onSuccess, currency }) {
    const { mutateAsync: addSeats, isLoading } = useAddSeats(subscriptionId, onSuccess);
    return <div className="space-y-4">
        <p>{formatCurrencyAmount(totalAmount, currency)} for {additionalSeats} additional seats</p>
        {isLoading ? <p role="status">Confirming payment…</p> : <Paypal amount={totalAmount} currency={currency}
            quotePayload={{ kind: "seats", subscription_id: subscriptionId, additional_seats: additionalSeats }}
            _onComplete={(order, quote) => addSeats({ additional_seats: additionalSeats, payment_method: "PayPal", currency, total_amount: totalAmount, reference: order.id, status: order.status === "COMPLETED" ? "Completed" : "Failed", quote_id: quote?.quote_id })} />}
    </div>;
}
